import { render, staticRenderFns } from "./WhatsappContacts.vue?vue&type=template&id=0cc9cf4b&scoped=true"
import script from "./WhatsappContacts.vue?vue&type=script&lang=js"
export * from "./WhatsappContacts.vue?vue&type=script&lang=js"
import style0 from "./WhatsappContacts.vue?vue&type=style&index=0&id=0cc9cf4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc9cf4b",
  null
  
)

export default component.exports